import React from "react";
import { Link } from "react-router-dom";

const AuthHeader = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginBottom: "30px",
        width: "100%",
      }}
    >
      <Link
        to="/"
        style={{
          textDecoration: "none",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* Logo/Avatar Container */}
        <div
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            backgroundColor: "#f3e1b2",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "10px",
            overflow: "hidden",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          <img
            src="/links_avatar/normal_links.png"
            alt="Links"
            style={{
              width: "120%",
              height: "120%",
              objectFit: "contain",
              objectPosition: "center 60%",
            }}
            draggable="false"
          />
        </div>

        {/* App Name */}
        <h1
          style={{
            color: "#333",
            fontSize: "32px",
            fontWeight: "700",
            margin: "0",
            fontFamily: "'Inter', sans-serif",
          }}
        >
          Links
        </h1>

        {/* Tagline */}
        <p
          style={{
            color: "#666",
            fontSize: "14px",
            margin: "4px 0 0",
            fontFamily: "'Inter', sans-serif",
          }}
        >
          Your personal math tutor
        </p>
      </Link>
    </div>
  );
};

export default AuthHeader;
